import PropTypes from 'prop-types'
import {
  Box,
  Button,
  Center,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useTheme,
  VStack,
} from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import Table from '../../../components/Table/Table'
import { REPOSITORY } from '../../../api/repository/Repository'
import { formatStringNumber } from '../../../utils/formats/formats'
// const useHistoricalDetailData = (nDocument) => {}

const descriptionTableColumns = [
  { id: 'Linea', Header: 'Linea' },
  { id: 'Descripcion', Header: 'Descripción' },
  { id: 'MontoNeto', Header: 'Monto neto', type: 'currency' },
]
const descriptionBillingTableColumns = [
  { id: 'NumeroRecarga', Header: 'N* de recarga' },
  { id: 'CentroCosto', Header: 'Centro de costo' },
  { id: 'Fecha', Header: 'Fecha', type: 'date' },
  { id: 'Descripcion', Header: 'Descripción' },
  { id: 'Monto', Header: 'Monto', type: 'currency' },
]
const MovementInfo = ({ label, data }) => {
  return (
    <HStack justifyContent="space-between" w="100%">
      <Box>
        <Text variant="subtitle2" color="#000000">
          {label}
        </Text>
      </Box>
      <Box>
        <Text variant="body2" color="#000000">
          {data}
        </Text>
      </Box>
    </HStack>
  )
}

const BillingDetails = ({
  data: {
    FechaEmision,
    nDocumento,
    FechaVencimiento,
    Hes_OC,
    Neto,
    Iva,
    total,
  },
}) => {
  return (
    <HStack w="100%" justifyContent="space-between" alignItems="flex-start">
      <VStack w="40%" alignItems="flex-start">
        <MovementInfo label={'N° Factura:'} data={nDocumento} />
        <MovementInfo label={'Fecha emisión:'} data={FechaEmision} />
        <MovementInfo label={'Fecha de vencimiento:'} data={FechaVencimiento} />
        <MovementInfo label={'HES/OC'} data={Hes_OC} />
      </VStack>
      <VStack w="20%" justifyContent="flex-start">
        <MovementInfo label={'Neto:'} data={formatStringNumber(Neto)} />
        <MovementInfo label={'IVA:'} data={formatStringNumber(Iva)} />
        <MovementInfo label={'Total:'} data={formatStringNumber(total)} />
      </VStack>
    </HStack>
  )
}

BillingDetails.propTypes = {
  data: PropTypes.object,
}

MovementInfo.propTypes = {
  data: PropTypes.string,
  label: PropTypes.string,
}
export default function HistoricalDetails({ isOpen, onClose, nDocument }) {
  const { colors } = useTheme()
  const [historicalDetail, setHistoricalDetail] = useState(null)
  const getHistoricalDetail = async () => {
    await REPOSITORY.wsEmpresa.company
      .getHistoricMovementByDocument(nDocument)
      .then((res) => {
        setHistoricalDetail(res.data)
      })
  }
  useEffect(() => {
    if (isOpen) {
      getHistoricalDetail()
    }

    return () => {
      if (!isOpen) {
        setHistoricalDetail(null)
      }
    }
  }, [isOpen])

  return (
    <>
      <Modal size="3xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            bgColor={colors.primary.base}
            borderRadius="5px 5px 0px 0px"
          >
            <Text
              textAlign="center"
              color={colors.gray['50-0']}
              variant="subtitle2"
            >{`Factura N* ${nDocument}`}</Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody p={0}>
            <VStack
              w="100%"
              alignItems="flex-start"
              justifyContent="flex-start"
            >
              <VStack
                p="16px"
                w="100%"
                alignItems="flex-start"
                justifyContent="flex-start"
              >
                <BillingDetails
                  data={historicalDetail?.DatosFacturaVenta || {}}
                />
                <Table
                  data={historicalDetail?.DetalleFacturaVenta || []}
                  columns={descriptionTableColumns}
                />
              </VStack>
              <VStack
                spacing={0}
                w="100%"
                alignItems="flex-start"
                justifyContent="flex-start"
              >
                <ModalHeader
                  w="100%"
                  position="relative"
                  bgColor={colors.primary.base}
                  borderRadius="5px 5px 0px 0px"
                >
                  <Text
                    textAlign="center"
                    color={colors.gray['50-0']}
                    variant="subtitle2"
                  >
                    Detalle de movimientos facturados
                  </Text>
                </ModalHeader>
                <Table
                  columns={descriptionBillingTableColumns}
                  data={historicalDetail?.DetalleMovFacturados || []}
                />
              </VStack>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Center w="100%">
              <Button variant="gray800" w="116px" onClick={onClose}>
                Cerrar
              </Button>
            </Center>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

HistoricalDetails.propTypes = {
  isOpen: PropTypes.bool,
  nDocument: PropTypes.string,
  onClose: PropTypes.func,
}
